<script>
  import { getContext } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Link, link, Route, Router, useLocation } from 'svelte-navigator';
  import { Breadcrumb, BreadcrumbItem, Button, Col, Container, Row } from '@sveltestrap/sveltestrap';

  import Redirect from '@client/app/redirect.svelte';

  import { Loader } from '@client/components/loader';

  import { ASSET_TYPES, IMAGE_UPLOAD_TYPES } from '@client/enums';

  import { Documents } from './documents';
  import { Images } from './images';
  import { DocumentModal, ImageBulkModal, ImageChoiceModal, ImageSingleModal, VideoModal } from './modals';
  import { Videos } from './videos';

  const { basepath } = getContext('config');
  const location = useLocation();

  let choice = '';
  let loading = false;
  let type = '';
  let showAssetModal = false;
  let showImageChoiceModal = false;
  let refetch = false;

  const getProps = ({ href, location }) => {
    const isActive = href.replace(basepath, '') === location.pathname || href.includes(location.pathname) || false;

    if (isActive) {
      return {
        class: 'tab active'
      };
    }

    return {};
  };

  const onAddAsset = () => (showAssetModal = true);

  $: pathname = $location.pathname;
  $: isDocuments = pathname === '/manage/assets/documents';
  $: isImages = pathname === '/manage/assets/images';
  $: isVideos = pathname === '/manage/assets/videos';
  $: type = isDocuments ? ASSET_TYPES.documents.id : isImages ? ASSET_TYPES.images.id : ASSET_TYPES.videos.id;
</script>

<div class="page">
  <Loader backdrop show={loading} />
  <div class="page-header">
    <Container fluid>
      <Row>
        <Col md="12">
          <Breadcrumb>
            <BreadcrumbItem>
              <a href="{basepath}/manage/users" use:link>{$format('label.MANAGE')}</a>
            </BreadcrumbItem>
            <BreadcrumbItem active>{$format('label.ASSETS')}</BreadcrumbItem>
          </Breadcrumb>
        </Col>
      </Row>
      <Row class="flex-align--center">
        <Col xs="6" sm="6" md="8">
          <h1 class="page-title">{$format('label.ASSETS')}</h1>
        </Col>
        <Col class="text-right">
          <Button color="secondary" on:click={onAddAsset}>
            {#if isDocuments}
              {$format('label.DOCUMENT_MODAL_NEW_DOCUMENT')}
            {:else if isImages}
              {$format('label.IMAGE_MODAL_NEW_IMAGE')}
            {:else if isVideos}
              {$format('label.VIDEO_MODAL_NEW_VIDEO')}
            {/if}
          </Button>
        </Col>
      </Row>
    </Container>
  </div>
  <div class="page-content">
    <Container fluid>
      <Row>
        <div class="tabs">
          <div class="tab-list">
            <Link to="images" {getProps}>{$format('label.IMAGES')}</Link>
            <Link to="documents" {getProps}>{$format('label.DOCUMENTS')}</Link>
            <Link to="videos" {getProps}>{$format('label.VIDEOS')}</Link>
          </div>
        </div>

        <div class="tab-content pt-4 pb-4">
          <Router>
            <Route path="documents/*">
              <Documents bind:refetch {onAddAsset} />
            </Route>
            <Route path="images/*">
              <Images bind:refetch {onAddAsset} />
            </Route>
            <Route path="videos/*">
              <Videos bind:refetch {onAddAsset} />
            </Route>
            <Route path="/*">
              <Redirect path="{basepath}/manage/assets/images" config={{ replace: true }} />
            </Route>
          </Router>
        </div>
      </Row>
    </Container>
  </div>
</div>

{#if type === ASSET_TYPES.documents.id}
  <DocumentModal bind:show={showAssetModal} bind:refetch />
{:else if type === ASSET_TYPES.images.id}
  <ImageChoiceModal bind:show={showAssetModal} bind:choice bind:showNextModal={showImageChoiceModal} />
  {#if choice === IMAGE_UPLOAD_TYPES.single.id}
    <ImageSingleModal bind:show={showImageChoiceModal} bind:refetch bind:showPreviousModal={showAssetModal} />
  {:else if choice === IMAGE_UPLOAD_TYPES.bulk.id}
    <ImageBulkModal bind:show={showImageChoiceModal} bind:refetch bind:showPreviousModal={showAssetModal} />
  {/if}
{:else if type === ASSET_TYPES.videos.id}
  <VideoModal bind:show={showAssetModal} bind:refetch />
{/if}

<style lang="scss" src="./assets.scss"></style>
